import React from 'react';
import { ContentfulImage } from '../Contentful';
import './ScatteredCollageGallery.css';

interface ScatteredCollageGalleryProps {
  images: {
    topLeft: string;
    rightCenter: string;
    bottomRight: string;
  };
  className?: string;
}

const ScatteredCollageGallery: React.FC<ScatteredCollageGalleryProps> = ({ 
  images, 
  className = '' 
}) => {
  return (
    <div className={`scattered-collage-gallery ${className}`}>
      {/* Top Left Image */}
      <div className="scattered-image scattered-top-left">
        <ContentfulImage 
          imageKey="gallery-main" 
          fallbackSrc={images.topLeft}
          alt="Luxury wilderness landscape showcasing pristine natural beauty"
        />
      </div>
      
      {/* Right Center Image */}
      <div className="scattered-image scattered-right-center">
        <ContentfulImage 
          imageKey="gallery-main" 
          fallbackSrc={images.rightCenter}
          alt="Intimate moment of discovery in the untouched wilderness"
        />
      </div>
      
      {/* Bottom Right Image */}
      <div className="scattered-image scattered-bottom-right">
        <ContentfulImage 
          imageKey="gallery-main" 
          fallbackSrc={images.bottomRight}
          alt="Expansive vista of rugged terrain and endless skies"
        />
      </div>
    </div>
  );
};

export default ScatteredCollageGallery;